import { IBaseModel } from "./abstract/ibaseModel.interface";


export class CustomerPriceList implements IBaseModel {
    id: number;
    customerId: number;
    priceListId: number;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/customerPriceList.model.ts